var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17.5","stroke":"#00AF41","key":0}),React.createElement("path",{"d":"M21.507 23.5C21.2495 23.5 20.9984 23.4141 20.7975 23.2365C20.4019 22.8813 20.4019 22.2969 20.7912 21.9417L25.0733 18L20.7912 14.0641C20.4019 13.7031 20.4082 13.1245 20.7975 12.7636C21.193 12.4084 21.8272 12.4141 22.2227 12.7693L27.208 17.3526C27.5973 17.7078 27.5973 18.2865 27.208 18.6417L22.2227 23.225C22.0218 23.4083 21.7644 23.5 21.507 23.5Z","fill":"#2C2C2C","key":1}),React.createElement("circle",{"cx":"19.0059","cy":"18","r":"1.5","fill":"#2C2C2C","key":2}),React.createElement("circle",{"cx":"14.0059","cy":"18","r":"1.5","fill":"#2C2C2C","key":3}),React.createElement("circle",{"cx":"9.00586","cy":"18","r":"1.5","fill":"#2C2C2C","key":4})]);
}

ArrowIcon.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
